import React from 'react';
import PropTypes from 'prop-types';
import Formsy from 'formsy-react';
import RaisedButton from 'material-ui/RaisedButton';
import { Box } from '@material-ui/core';
import moment from 'moment';

import { refSetter } from '../../utils/helpers';
import FilterPanel from './FilterPanel';
import globals from '../../globals/communityGlobals';

const locale = globals.getArea('reports');

class ReportForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      canGenerate: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.name === 'TreatmentDeliveryReport') this.handleClear();
  }

  setRef = refSetter.bind(this);

  setValidity = value => () => {
    this.setState({
      canGenerate: value,
    });
  };

  handleSubmit = values => {
    const { generateReport, name } = this.props;

    const {
      areasIds,
      boroughsIds,
      teamsIds,
      startDate,
      endDate,
      activityId,
      cliniciansIds,
      referralServiceIds,
      ...rest
    } = values;
    generateReport({
      ...rest,
      activityId,
      startDate: moment(startDate).format(globals.dateFormats.date),
      endDate: moment(endDate).format(globals.dateFormats.date),
      orgUnitsIds: []
        .concat(areasIds)
        .concat(boroughsIds)
        .concat(teamsIds),
      cliniciansIds,
      referralServiceIds,
      reportType: name,
    });
  };

  handleClear = () => {
    this.form.reset();
  };

  render() {
    const { canGenerate } = this.state;
    const { filters, filtersRestrictions, isGenerating, handleFilterChange } = this.props;
    return (
      <Formsy.Form
        ref={this.setRef('form')}
        onValid={this.setValidity(true)}
        onInvalid={this.setValidity(false)}
        onValidSubmit={this.handleSubmit}
        className="search-box"
      >
        {this.props.name === 'TreatmentDeliveryReport' && (
          <FilterPanel
            filters={filters}
            filtersRestrictions={filtersRestrictions}
            onValuesChange={reportData => handleFilterChange(reportData)}
            name={this.props.name}
          />
        )}
        {this.props.name !== 'TreatmentDeliveryReport' && (
          <FilterPanel
            filters={filters}
            onValuesChange={reportData => handleFilterChange(reportData)}
            name={this.props.name}
          />
        )}
        <Box display="flex" flexDirection="row" p={1}>
          <Box p={1} flexGrow={1}>
            <RaisedButton
              type="submit"
              label={locale.getMsg('generate')}
              disabled={!canGenerate || isGenerating}
              primary
            />
          </Box>
        </Box>
        {isGenerating && <span style={{ paddingLeft: '10px' }}>{locale.getMsg('isGenerating')}</span>}
      </Formsy.Form>
    );
  }
}

ReportForm.defaultProps = {
  selectedReport: {},
  filtersRestrictions: {
    maxRangeInDays: null,
  },
};

ReportForm.propTypes = {
  generateReport: PropTypes.func.isRequired,
  handleFilterChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  filters: PropTypes.shape({
    teams: PropTypes.bool,
    dateRange: PropTypes.bool,
    period: PropTypes.bool,
    clinicians: PropTypes.bool,
    nhsNumber: PropTypes.bool,
    activity: PropTypes.bool,
  }).isRequired,
  filtersRestrictions: PropTypes.shape({
    maxRangeInDays: PropTypes.number,
  }),
};

export default ReportForm;
